import React from 'react';
import './Fun.css';

function Fun() {
  return (
    <div id="fun">
        <div class="container">
            
        </div>
    </div>
  );
}

export default Fun;
